import React, { useState } from 'react';
import {
    Box,
    Typography,
    Button,
    Collapse,
    IconButton,
    Paper,
    Grid,
    Dialog,
    DialogContent,
    DialogTitle,
    Tooltip,
    Fab, Chip
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Close as CloseIcon,
  FormatListBulleted as ListIcon
} from '@mui/icons-material';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
const ResponseSuggestions = ({ options, onSelectOption }) => {
  const [modalOpen, setModalOpen] = useState(false);

  // Handle option selection
  const handleSelect = (optionText) => {
    onSelectOption(optionText);
    setModalOpen(false); // Close modal after selection
  };

  if (!options || options.length === 0) return null;

  return (
    <>
      {/* Minimalist toggle button */}
      <Tooltip title="Show suggested responses" placement="top">
        <Chip
        label="Suggestions"
        size="small"
        onClick={() => setModalOpen(true)}
        icon={<LightbulbOutlinedIcon fontSize="small" sx={{ color: 'white' }} />}
        sx={{
          position: 'absolute',
          top: -10,
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: 'primary.main', // Blue background
          color: 'white', // White text
          boxShadow: 1,
          '& .MuiChip-icon': {
            color: 'white', // Ensure icon is white
          },
          '&:hover': {
            backgroundColor: 'primary.dark', // Slightly darker blue on hover
          }
        }}
      />
      </Tooltip>

      {/* Modal with response options */}
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        maxWidth="sm"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: 2,
            mx: 2
          }
        }}
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">Suggestions</Typography>
            <IconButton size="small" onClick={() => setModalOpen(false)}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={1.5}>
            {options.map((option) => (
              <Grid item xs={12} key={option.number}>
                <Button
                  fullWidth
                  variant="outlined"
                  color="primary"
                  onClick={() => handleSelect(option.response)}
                  sx={{
                    justifyContent: 'flex-start',
                    textAlign: 'left',
                    p: 1.5,
                    borderRadius: 1.5,
                    whiteSpace: 'normal',
                    height: 'auto',
                    fontWeight: 'normal'
                  }}
                >
                  <Box sx={{ width: '100%' }}>
                    <Typography
                      variant="caption"
                      sx={{
                        display: 'block',
                        mb: 0.5,
                        color: 'text.secondary',
                        fontWeight: 'medium'
                      }}
                    >
                    </Typography>
                    <Typography variant="body2">{option.response}</Typography>
                  </Box>
                </Button>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ResponseSuggestions;